// The record footer: "Record Created By: <name> On <date> | Record Modified By: <name> On <date>".
//
// A side whose user is unknown reads "Record Created On <date>" — never an empty "By:" (Aaron
// 2026-10-12, mustang W/O 337: created_by / modified_by 0, no such user, footer read
// "Record Created By:  On 05-Oct-2026"; ruling "Hide empty 'By:'"). A side with neither a name
// nor a date is left out. With a name present the text is exactly what it always was.
// Kept apart from formatAuditTimestamp.ts, which is byte-identical to upstream.
import { formatAuditTimestamp } from "./formatAuditTimestamp";

export interface AuditSide {
  /** The user's display name; blank / missing when the row names no (known) user. */
  name?: string | null;
  /** The created / modified timestamp. */
  at?: string | Date | null;
}

function side(verb: "Created" | "Modified", name: string | null | undefined, when: string | null | undefined): string {
  const who = (name ?? "").trim();
  const on = (when ?? "").trim() ? ` On ${(when ?? "").trim()}` : "";
  if (!who && !on) return "";
  return who ? `Record ${verb} By: ${who}${on}` : `Record ${verb}${on}`;
}

/**
 * The footer from names and ALREADY-FORMATTED dates — for a screen that resolves its own
 * user names and formats its own dates, and only needs the shared wording.
 */
export function auditSubtitleText(
  createdBy: string | null | undefined,
  dateCreated: string | null | undefined,
  modifiedBy: string | null | undefined,
  dateModified: string | null | undefined
): string {
  return [side("Created", createdBy, dateCreated), side("Modified", modifiedBy, dateModified)]
    .filter(Boolean)
    .join(" | ");
}

/** The footer from names and raw timestamps (formatted with formatAuditTimestamp). */
export function formatAuditSubtitle(created: AuditSide, modified: AuditSide, dateFormat: string | undefined): string {
  return auditSubtitleText(
    created.name,
    formatAuditTimestamp(created.at ?? undefined, dateFormat),
    modified.name,
    formatAuditTimestamp(modified.at ?? undefined, dateFormat)
  );
}
